eval("/* global asap */\nrequirejs.nextTick = asap;\nfor (var contextName in requirejs.s.contexts) {\n    if (requirejs.s.contexts.hasOwnProperty(contextName)) {\n        require.s.contexts[contextName].nextTick = asap;\n    }\n}\n\n//# sourceURL=/home/quevedosiacemlap/public_html/siacem/web/bundles/ororequirejs/js/requirejs-asap-init.js");

define("requirejs-asap-init", ["asap"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.asap;
    };
}(this)));

